if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

     /* Function select menu */
        document.querySelectorAll(".js-menu-tab").forEach((btn) => {
            btn.addEventListener("click", (_) => {
            $(".js-menu-tab.active").removeClass("active");
            $(btn).addClass("active");
            $(".js-menu-content.active").removeClass("active");
            var tabNumber = $(btn).attr("data-menuid");
            var tabToOpen =
                ".js-menu-content[data-menuid='" + tabNumber + "']";
            $(tabToOpen).addClass("active");
            $(".quad-menus__tabs-image.active").removeClass("active");
            var imgToOpen =
                ".quad-menus__tabs-image[data-menuid='" + tabNumber + "']";
            $(imgToOpen).addClass("active");
            $(".name-bg.active").removeClass("active");
            var wordToOpen = ".name-bg[data-menuid='" + tabNumber + "']";
            $(wordToOpen).addClass("active");
            });
        });

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));


    $('.sym-slides').slick({
        accessibility: false
    });

    
    $(".home-slick").slick({
        fade:true,
        infinite: true,
        arrows: false,
        dots: false,
        autoplay: false,
        speed: 1000,
        swipe:false,
        slidesToShow: 1,
        slidesToScroll: 1,
    });

    //   Progress Bar Function ************************************************

        var percentTime;
        var tick;
        var time = .1;
        var progressBarIndex = 0;
    
        $('.progressBarContainer .progressBar').each(function(index) {
            var progress = "<div class='inProgress inProgress" + index + "'></div>";
            $(this).html(progress);
        });
    
        function startProgressbar() {
            resetProgressbar();
            percentTime = 0;
            tick = setInterval(interval, 10);
        }
    
        function interval() {
            if (($('.home-slick .slick-track div[data-slick-index="' + progressBarIndex + '"]').attr("aria-hidden")) === "true") {
                progressBarIndex = $('.home-slick .slick-track div[aria-hidden="false"]').data("slickIndex");
                startProgressbar();
            } else {
                percentTime += 1 / (time + 5);
                $('.inProgress' + progressBarIndex).css({
                    width: percentTime + "%"
                });
                if (percentTime >= 100) {
                    $('.home-slick').slick('slickNext');
                    progressBarIndex++;
                    if (progressBarIndex > 2) {
                        progressBarIndex = 0;
                    }
                    startProgressbar();
                }
            }
        }
    
        function resetProgressbar() {
            $('.inProgress').css({
                width: 0 + '%'
            });
            clearInterval(tick);
        }
        startProgressbar();      
        $('.item').click(function () {
            clearInterval(tick);
            var goToThisIndex = $(this).find("span").data("slickIndex");
            $('.home-slick').slick('slickGoTo', goToThisIndex, false);
            startProgressbar();
        });


    $('.menus-tabs__slider').slick({
        fade:true,
        autoplay: false,
        autoplaySpeed: 4000,
        arrows:false
    })

    $('.single_slider').slick({
        fade:true,
        autoplay: false,
        autoplaySpeed: 4000,
        arrows:true,
        responsive: [
            {
              breakpoint: 700,
              settings: {
                arrows:false,
                dots:true,
                adaptiveHeight:true
              }
            }
        ]
    })

    $('.reviews_slider').slick({
        fade:true,
        slidesToShow: 1,
        autoplay: false,
        autoplaySpeed: 4000,
        arrows:false,
        dots:true
    })
    $('.hours-block__slider').slick({
        fade:true,
        slidesToShow: 1,
        arrows:true
    })
    $('.gallery_mobile_slider').slick({
        fade:true,
        slidesToShow: 1,
        arrows:true
    })

    function getParams( url ){ 
        let params = url.split('?')[1]; 
        let paramsArray = params.split('&'); 
        let paramsObject = { 
            key: paramsArray[0].split('=')[0], 
            value: paramsArray[0].split('=')[1]
        }; 
        return paramsObject; 
        }
    function hasUrLParams( url ) { 
        return url.indexOf('?') !== -1; 
    }
    // function scrollToElement(element) { 
    //     element.scrollIntoView({ 
    //         behavior: "smooth", 
    //         block: "start"
    //     });
    // }
    if(hasUrLParams( window.location.href )) { 
        let { value } = getParams( window.location.href );
        if(document.querySelector(`.quad-menus`)){ 
            let targetQuad = document.querySelector(`.quad-menus`); 
            let targetMenu = document.querySelector(`.js-menu-tab[data-menuname=${value}]`);
            targetQuad.scrollIntoView({ 
                behavior: "smooth", 
                block: "start"
            });
            targetMenu.click();
             
        } 
    }
    
    
})();

